import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";
import { PdfPicker } from "./PdfPicker";

const KEYS = [["height", "Altezza"], ["bust", "Seno"], ["waist", "Vita"], ["hips", "Fianchi"], ["shoes", "Scarpe"], ["hair", "Capelli"], ["eyes", "Occhi"]];
const slugify = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
const cls = "mt-1 w-full border-b border-[#1c1418]/30 bg-transparent py-2 outline-none focus:border-[#1c1418]";

export const ModelForm = ({ model, onClose, onSaved }) => {
  const [f, setF] = useState({
    name: model.name || "", slug: model.slug || "", gender: model.gender || "F", instagram: model.instagram || "",
    featured: !!model.featured, measurements: { ...(model.measurements || {}) }, images: (model.images || []).join("\n"),
    pdf_cover: model.pdf_cover || "", pdf_grid: model.pdf_grid || [],
  });
  const [busy, setBusy] = useState(false);
  const imageList = f.images.split("\n").map((s) => s.trim()).filter(Boolean);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    const body = {
      ...f, slug: f.slug || slugify(f.name), images: imageList,
      pdf_cover: imageList.includes(f.pdf_cover) ? f.pdf_cover : "",
      pdf_grid: f.pdf_grid.filter((g) => imageList.includes(g)),
    };
    try {
      if (model.id) await api.put(`/admin/models/${model.id}`, body);
      else await api.post("/admin/models", body);
      toast.success("Salvato");
      onSaved();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="model-form-dialog" data-lenis-prevent className="max-h-[90vh] max-w-3xl overflow-y-auto rounded-none bg-white">
        <DialogHeader><DialogTitle className="font-display text-4xl uppercase">{model.id ? "Modifica modella" : "Nuova modella"}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-5">
          <div className="grid gap-4 sm:grid-cols-2">
            <label className="font-mono text-[11px] uppercase tracking-[0.2em]">Nome<input data-testid="model-name-input" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value, slug: model.id ? f.slug : slugify(e.target.value) })} className={cls} /></label>
            <label className="font-mono text-[11px] uppercase tracking-[0.2em]">Slug (URL)<input data-testid="model-slug-input" required value={f.slug} onChange={(e) => setF({ ...f, slug: slugify(e.target.value) })} className={cls} /></label>
            <label className="font-mono text-[11px] uppercase tracking-[0.2em]">Sesso
              <select data-testid="model-gender-select" value={f.gender} onChange={(e) => setF({ ...f, gender: e.target.value })} className={cls}><option value="F">Donna</option><option value="M">Uomo</option></select>
            </label>
            <label className="font-mono text-[11px] uppercase tracking-[0.2em]">Instagram<input data-testid="model-instagram-input" value={f.instagram} onChange={(e) => setF({ ...f, instagram: e.target.value })} className={cls} /></label>
          </div>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
            {KEYS.map(([k, l]) => (
              <label key={k} className="font-mono text-[11px] uppercase tracking-[0.2em]">{l}
                <input data-testid={`model-${k}-input`} value={f.measurements[k] || ""} placeholder={k === "height" ? "178 - 5' 10\"" : ""}
                  onChange={(e) => setF({ ...f, measurements: { ...f.measurements, [k]: e.target.value } })} className={cls} />
              </label>
            ))}
          </div>
          <label className="block font-mono text-[11px] uppercase tracking-[0.2em]">Foto (un link per riga, la prima è la copertina)
            <textarea data-testid="model-images-input" rows={5} value={f.images} onChange={(e) => setF({ ...f, images: e.target.value })} className={`${cls} font-mono text-xs normal-case`} />
          </label>
          <PdfPicker images={imageList} cover={f.pdf_cover} grid={f.pdf_grid}
            onChange={({ cover, grid }) => setF({ ...f, pdf_cover: cover, pdf_grid: grid })} />
          <label className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em]">
            <input data-testid="model-featured-checkbox" type="checkbox" checked={f.featured} onChange={(e) => setF({ ...f, featured: e.target.checked })} /> In evidenza in homepage
          </label>
          <button data-testid="model-save-button" disabled={busy} className="w-full bg-[#1c1418] text-white py-4 font-mono text-xs uppercase tracking-[0.25em] disabled:opacity-60">{busy ? "Salvataggio…" : "Salva"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
